const selectraThemePrimitives = {
  primaryFontFamily: '"Source Sans Pro", system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif',

  primary: '#1460AA',
  primary50: '#E8EFF7',
  primary100: '#E0FFFF',
  primary150: '#C7FFFF',
  primary200: '#ADF9FF',
  primary250: '#93DFFF',
  primary300: '#7AC6FF',
  primary350: '#61ADF7',
  primary400: '#015AA3',
  primary450: '#2E7AC4',
  primary500: '#1460AA',
  primary550: '#004791',
  primary600: '#002D77',
  primary650: '#00145E',
  primary700: '#000044',
  primary750: '#00002B',
  primary800: '#000011',

  accent: '#D97F18',
  accent50: '#FBF2E8',
  accent100: '#FFFFE4',
  accent150: '#FFFFCB',
  accent200: '#FFFFB1',
  accent250: '#FFFF98',
  accent300: '#FFE57E',
  accent350: '#FFCC65',
  accent400: '#FFB24B',
  accent450: '#F39932',
  accent500: '#D97F18',
  accent550: '#C06600',
  accent600: '#A64C00',
  accent650: '#8D3300',
  accent700: '#731900',
  accent750: '#5A0000',
  accent800: '#400000',

  negative: '#DC0909',
  negative50: '#FFEEEE',
  negative100: '#FEE9E9',
  negative150: '#FFD5D5',
  negative200: '#FFBBBB',
  negative250: '#FFA2A2',
  negative300: '#FF8888',
  negative350: '#FF6F6F',
  negative400: '#FF5555',
  negative450: '#FF3C3C',
  negative500: '#F52222',
  negative550: '#DC0909',
  negative600: '#C20000',
  negative650: '#A90000',
  negative700: '#8F0000',
  negative750: '#760000',
  negative800: '#5C0000',

  warning: '#C45405',
  warning50: '#FCF0E9',
  warning100: '#FFFFEA',
  warning150: '#FFEBC3',
  warning200: '#FFFFB7',
  warning250: '#FFED9E',
  warning300: '#D2A604',
  warning350: '#FFBA6B',
  warning400: '#FFA051',
  warning450: '#F78738',
  warning500: '#DD6D1E',
  warning550: '#C45405',
  warning600: '#AA3A00',
  warning650: '#912100',
  warning700: '#770700',
  warning750: '#5E0000',
  warning800: '#440000',

  positive: '#0C8A1E',
  positive50: '#E9F6EB',
  positive100: '#F1FFFF',
  positive150: '#D8FFEA',
  positive200: '#BEFFD0',
  positive250: '#A5FFB7',
  positive300: '#8BFF9D',
  positive350: '#72F084',
  positive400: '#58D66A',
  positive450: '#3FBD51',
  positive500: '#25A337',
  positive550: '#0C8A1E',
  positive600: '#007004',
  positive700: '#003D00',
  positive750: '#002400',
  positive800: '#000A00',

  white: '#FFFFFF',
  mono100: '#DEE8F2',
  mono200: '#C1D1E2',
  mono300: '#A8BACD',
  mono400: '#93A3B4',
  mono500: '#828C97',
  mono600: '#6B7580',
  mono700: '#565E67',
  mono800: '#41474E',
  mono900: '#2C3135',
  mono1000: '#171A1C',
  black: '#0C0D0E',

  grey: '#58595B',
  bg050: '#E9EEFB',
  bg100: '#D3E6F8',
  bg150: '#BDD9F4',

  // Text grays
  textHeading: '#343535',
  textBody: '#2C2C2C',
  textMuted: '#6B7280',
  textDark: '#111827',
  textMedium: '#374151',
  textLight: '#888',
  textSubtle: '#999',
  textSecondaryAlt: '#5F5F5F',
  textNearBlack: '#222',
  textDimmed: '#555',
  textDeep: '#204b78',
  textDisabled: '#8A8A8A',
  textLabel: '#666666',
  textLoading: '#7B868C',
  textBtnDisabled: '#AAAAAA',

  // Utility / semantic colors
  errorInput: '#B30F16',
  successAlt: '#0F9D58',
  successBg: '#D1F8CB',
  errorBg: '#FEE2E2',
  warningBg: '#FFF5DE',
  warningText: '#B65900',
  linkBlue: '#0063F7',

  // Background shades
  bgHover: '#F5F8FC',
  bgSubtle: '#F9FAFB',
  bgLight: '#F8F9FA',
  bgMuted: '#F3F4F6',
  bgSoft: '#f3f8fc',
  bgWash: '#f5f6fa',
  bgWashAlt: '#f3f4f6',
  bgFallback: '#f0f0f0',
  bgDisabled: '#F1F3F7',
  bgPanel: '#fafbfc',
  bgHoverLight: '#f8fafc',
  bgInactive: '#f6f6f6',
  bgActiveBlue: '#EEF2FF',
  bgActiveBlueStrong: '#E0E7FF',
  bgAccordion: '#F0F3F8',

  // Border / separator shades
  borderLight: '#E6EAF2',
  borderMuted: '#E5E5E5',
  borderFallback: '#e0e0e0',
  borderSoft: '#D6D7D8',
  borderSubtle: '#E6E6E6',
  borderMedium: '#D0D0D0',
  borderInput: '#A9ABAE',
  borderErrorLight: '#F87171',
  borderErrorPink: 'rgb(255, 187, 187)',
  borderGroupIdle: '#EDEEEE',

  // Accent / highlight
  highlightYellow: '#ffe066',
  badgeGrey: '#9CA3AF',
  barInactive: '#B0B0B0',
  primaryBright: '#2563EB',
  primaryAlt: '#015AA3',
  goldAccent: '#D2AB68',
  levelBorder: '#ECEEF3',
  iconMuted: '#808284',

  // Semantic / error
  errorTextAlt: 'rgb(255, 85, 85)',

  // Overlays (white with opacity)
  overlayWhite18: 'rgba(255,255,255,.18)',
  overlayWhite50: 'rgba(255,255,255,0.5)',
  overlayWhite60: 'rgba(255,255,255,0.6)',
  overlayWhite80: 'rgba(255,255,255,0.8)',

  // Overlays (colored, with opacity)
  overlayPrimary12: 'rgba(20, 96, 170, 0.12)',
  overlayDark80: 'rgba(44, 49, 53, 0.8)',

  // Shadows
  shadowCard: '0 0.0625rem 0.25rem rgba(30, 30, 30, 0.07)',
  shadowElevated: '0 0.625rem 1.75rem rgba(0,0,0,0.08)',
  shadowPrimary: '0 2px 6px rgba(20,96,170,.3)',

  // Gradient
  gradientBlueStart: '#4793dd',
  gradientBlueEnd: '#004791',
  gradientGoldStart: '#ffd000',
  gradientGoldEnd: '#ff8c00',

  // PULSE palette (Client tab redesign)
  pulseCanvas: '#f0f4fb',
  pulseSlate100: '#f1f5f9',
  pulseSlate150: '#eef2f6',
  pulseSlate200: '#e2e8f0',
  pulseSlate300: '#cbd5e1',
  pulseSlate400: '#94a3b8',
  pulseSlate500: '#64748b',
  pulseSlate550: '#5b6a7d',
  pulseSlate600: '#475569',
  pulseSlate700: '#334155',
  pulseSlate900: '#0f172a',
  pulseBlueHover: '#014986',
  pulseBlueSelected: '#e6eff6',
  pulseBlue100: '#dbeafe',
  pulseBlue800: '#1e40af',
  pulseRed50: '#fef2f2',
  pulseRed200: '#fecaca',
  pulseRed600: '#dc2626',
  pulseRed700: '#b91c1c',
  pulseRed800: '#991b1b',
  pulseAmber50: '#fffbeb',
  pulseAmber100: '#fef3c7',
  pulseAmber200: '#fde68a',
  pulseAmber500: '#f59e0b',
  pulseAmber700: '#b45309',
  pulseAmber800: '#92400e',
  pulseGreen50: '#ecfdf5',
  pulseGreen100: '#d1fae5',
  pulseGreen200: '#a7f3d0',
  pulseGreen500: '#10b981',
  pulseGreen700: '#047857',
  pulseGreen800: '#065f46',
  pulseOrange50: '#fff7ed',
  pulseOrange800: '#9a3412',

  // PULSE shadows
  pulseShadowTab: '0 1px 2px rgba(0, 0, 0, 0.06)',
  pulseShadowSegment: '0 1px 2px rgba(0, 0, 0, 0.08)',
  pulseShadowThumb: '0 1px 2px rgba(0, 0, 0, 0.2)',
  pulseShadowDirtyTab: '0 1px 2px rgba(185, 28, 28, 0.4)',
  pulseShadowFocus: '0 0 0 2px rgba(1, 90, 163, 0.12)',
  pulseShadowMenu: '0 8px 24px rgba(0, 0, 0, 0.12)',
  pulseShadowPopover: '0 8px 24px rgba(15, 23, 42, 0.12)',
  pulseShadowModal: '0 20px 60px rgba(0, 0, 0, 0.2)',
  pulseShadowFlash: '0 0 0 4px rgba(245, 158, 11, 0.18)',
  pulseRingDirtyStart: '0 0 0 0 rgba(220, 38, 38, 0.45)',
  pulseRingDirtyEnd: '0 0 0 7px rgba(220, 38, 38, 0)',
}

export default selectraThemePrimitives
